import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (email: string, password: string) => 
  api.post('/api/auth/login', { email, password });

export const refreshToken = (refreshToken: string) =>
  api.post('/api/auth/refresh', { refreshToken });

// Companies
export const getCompanies = () => api.get('/api/companies');
export const createCompany = (data: any) => api.post('/api/companies', data);

// Users
export const getUsers = () => api.get('/api/users');
export const createUser = (data: any) => api.post('/api/users', data);

// Declarations
export const getDeclarations = () => api.get('/api/declarations');
export const createDeclaration = (data: any) => api.post('/api/declarations', data);
export const updateDeclaration = (id: number, data: any) => api.put(`/api/declarations/${id}`, data);
export const submitDeclaration = (id: number) => api.post(`/api/declarations/${id}/submit`);

// Reports
export const getReports = () => api.get('/api/reports');
export const generateReport = (data: any) => api.post('/api/reports/generate', data);

// Audit
export const getAuditLogs = () => api.get('/api/audit');

export default api;
